import styles from "./CardItem.module.scss";
import { ModalOverlay } from "../ModalOverlay";
import { useContext, useState } from "react";
import { DeleteProgram } from "../DeleteProgram";
import { ModeContext } from "../../context/ModeContext";
import { bool } from 'yup';

type CardItemProps = {
  id: number;
  img: string;
  name: string;
  text: string;
  list?: string[];
  isDeletable?: boolean;
  // onDelete: Function;
  element: JSX.Element;
};

export const CardItem = ({
  id,
  img,
  name,
  text,
  list,
  element,
 // onDelete,
 isDeletable = false,
}: CardItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { adminMode } = useContext(ModeContext);

  return (
    <div className={styles.wrapper}>
      {img ? (
        <div className={styles.img}>
          <img src={img} alt="img" />
        </div>
      ) : (
        <div className={styles.emptyImg} />
      )}
      <h4 className={styles.name}>{name}</h4>
      <div className={styles.text}>
        <p>{text}</p>
        {list && (
          <ul>
            {list.map((el) => (
              <li>{el}</li>
            ))}
          </ul>
        )}
      </div>
      {element}
      { isDeletable && (
        adminMode && (
          <button
            type="button"
            className={styles.delete}
            onClick={() => setIsOpen(!isOpen)}
          >
            Verwijderen
          </button>
        ) &&
        <ModalOverlay show={isOpen}>
          <DeleteProgram
            onToggle={() => setIsOpen(!isOpen)}
            name={name}
            id={id}
            // onDelete={onDelete}
          />
        </ModalOverlay>
        )
      }
    </div>
  );
};
